import React from "react";

const Logo1 = ({ size = 28 }) => (
  <div style={{ display:"flex", alignItems:"center", gap:8 }}>
    <svg width={size} height={size} viewBox="0 0 36 36" fill="none">
      <circle cx="18" cy="18" r="3" fill="#2563EB"/>
      <line x1="18" y1="18" x2="18" y2="7"  stroke="#2563EB" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="18" y1="18" x2="7"  y2="18" stroke="#60A5FA" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="18" y1="18" x2="29" y2="18" stroke="#60A5FA" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="18" y1="18" x2="11" y2="27" stroke="#2563EB" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="18" y1="18" x2="27" y2="27" stroke="#60A5FA" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="18" cy="6"  r="2.5" fill="#0F172A"/><circle cx="6"  cy="18" r="2.5" fill="#2563EB"/>
      <circle cx="30" cy="18" r="2.5" fill="#2563EB"/><circle cx="10" cy="28" r="2.5" fill="#0F172A"/>
    </svg>
    <div>
      <div style={{ fontSize:18, fontWeight:900, color:"#2563EB", letterSpacing:"0.04em", lineHeight:1.1 }}>HIRALITY</div>
      <div style={{ fontSize:8, fontWeight:600, color:"#9CA3AF", letterSpacing:"0.16em", textTransform:"uppercase" }}>A Hire Reality</div>
    </div>
  </div>
);

// Same content previously shown in the InfoPopup modal (type="terms")
// in HiralityGreen_Enhanced.jsx — moved here verbatim, now a real page.
const SECTIONS = [
  {h:"1. Acceptance of Terms",p:"By accessing or using the Hirality HRMS platform, you agree to be bound by these Terms and Conditions. If you do not agree, please discontinue use immediately."},
  {h:"2. Platform Usage",p:"Hirality is a SaaS HR management platform. Access is granted on a subscription basis. You may not resell, redistribute, or reverse-engineer the platform."},
  {h:"3. Data Ownership",p:"All employee and company data you enter into Hirality remains your property. We act as a data processor and do not sell or share your data with third parties."},
  {h:"4. Subscription & Billing",p:"Subscriptions are billed monthly or annually as selected. All fees are exclusive of applicable taxes. Payments are non-refundable except where required by law."},
  {h:"5. Uptime & SLA",p:"Hirality commits to 99.9% monthly uptime. Scheduled maintenance windows are announced 48 hours in advance."},
  {h:"6. Prohibited Activities",p:"You may not use Hirality to process unlawful data, conduct illegal employment practices, or attempt to breach system security."},
  {h:"7. Limitation of Liability",p:"Hirality's total liability shall not exceed the fees paid in the three months preceding any claim."},
  {h:"8. Governing Law",p:"These terms are governed by the laws of India. Disputes shall be subject to the courts in Bangalore, Karnataka."},
  {h:"9. Modifications",p:"We may update these terms from time to time. Continued use constitutes acceptance. Material changes will be communicated via email."},
];

export default function TermsOfService() {
  return (
    <div style={{ minHeight:"100vh", background:"#F8FAFC", fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
      {/* Header */}
      <div style={{ background:"#fff", borderBottom:"1px solid rgba(37,99,235,0.12)",
        padding:"18px 24px", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
        <a href="/" style={{ textDecoration:"none" }}><Logo1 size={30}/></a>
        <a href="/" style={{ fontSize:13, fontWeight:700, color:"#2563EB", textDecoration:"none",
          display:"flex", alignItems:"center", gap:6 }}>
          ← Back to Home
        </a>
      </div>

      {/* Content */}
      <div style={{ maxWidth:760, margin:"0 auto", padding:"48px 24px 80px" }}>
        <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:8 }}>
          <span style={{ fontSize:32 }}>📋</span>
          <h1 style={{ fontSize:30, fontWeight:900, color:"#0F172A", margin:0 }}>Terms & Conditions</h1>
        </div>
        <div style={{ fontSize:12, color:"#9CA3AF", letterSpacing:"0.06em", textTransform:"uppercase", marginBottom:36 }}>
          Hirality HRMS · June 2026
        </div>

        <div style={{ background:"#fff", borderRadius:20, padding:"36px 40px",
          boxShadow:"0 8px 40px rgba(15,10,40,0.06)", border:"1px solid rgba(37,99,235,0.08)" }}>
          {SECTIONS.map((s, i) => (
            <div key={i} style={{ marginBottom: i === SECTIONS.length - 1 ? 0 : 26 }}>
              <div style={{ fontSize:14, fontWeight:800, color:"#2563EB", marginBottom:8,
                display:"flex", alignItems:"center", gap:8 }}>
                <div style={{ width:4, height:16, borderRadius:2,
                  background:"linear-gradient(180deg,#2563EB,#3B82F6)", flexShrink:0 }}/>
                {s.h}
              </div>
              <p style={{ fontSize:14.5, color:"#374151", lineHeight:1.85, margin:0, paddingLeft:12 }}>{s.p}</p>
            </div>
          ))}
        </div>

        <div style={{ marginTop:28, padding:"18px 24px", borderRadius:14,
          background:"linear-gradient(135deg,rgba(37,99,235,0.06),rgba(6,182,212,0.04))",
          border:"1px solid rgba(37,99,235,0.12)", textAlign:"center" }}>
          <div style={{ fontSize:14, color:"#6B7280" }}>
            Questions? <a href="mailto:support@hirality.com" style={{ color:"#2563EB", fontWeight:700, textDecoration:"none" }}>support@hirality.com</a>
          </div>
        </div>
      </div>
    </div>
  );
}